module.exports = __webpack_public_path__ + "img/save-draft.14d0eaa1.svg";